import bridge from "@/utils/dsBridge";
import { BridgeCallHandlers } from "@/interfaces/enums";
import { Log2ClientParams } from "@/interfaces/common";
import rfStore from "./rfStore";

export default function log2Client(params: Log2ClientParams) {
	// client webview only
	const rfStoreState = rfStore.getRFState();
	if (!rfStoreState || !rfStoreState.model) {
		return;
	}
	if (typeof window === "undefined") return;

	const payload = params.payload ? params.payload : {};
	bridge.call(BridgeCallHandlers.ADD_EVENT, {
		url: window.location.href,
		...params,
		eventName: params.eventName,
		payload: {
			url: window.location.href,
			...payload,
		},
	});
}
